<script>
import service from '@/service';
import DatumFilterDropdown from '@/components/DatumFilterDropdown';
import ZnesekFilterDropdown from '@/components/DropdownFilters/ZnesekDropdown';
import UvoziPovracilaModal from '@/components/Modals/UvoziPovracilaModal';
import EditPovraciloModal from '@/components/Modals/EditPovraciloModal';
import StatusPovracilaFilterDropdown from '@/components/DropdownFilters/StatusPovracilaFilterDropdown';
import settings from '@/settings.js';

export default {
	name: 'povracila',
	components: {
		'datum-filter-dropdown': DatumFilterDropdown,
		'znesek-filter-dropdown': ZnesekFilterDropdown,
		'uvozi-povracila-modal': UvoziPovracilaModal,
		'edit-povracilo-modal': EditPovraciloModal,
		'status-povracila-filter-dropdown': StatusPovracilaFilterDropdown
	},
	filters: {
	},
	methods: {
		click_openUvoziPovracila: function ($event) {
			this.showError(null);
			this.$refs.uvoziPovracilaModal.showModal();
		},
		click_editPovracilo: function (povraciloData) {
			this.showError(null);
			this.$refs.editPovraciloModal.showModal(povraciloData);
		},
		click_removePovracilo: function (povraciloData) {
			this.$bvModal.msgBoxConfirm('Želite izbrisati povračilo #' + povraciloData.id + '?', {
				title: 'Potrdite brisanje poravčila',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					service.removePovracilo(povraciloData.id)
						.then(response => {
							this.table.items = this.table.items.filter(function (value, index, arr) {
								return value.id !== povraciloData.id;
							});
							this.showError(null);
							this.$refs.dataTable.refresh();
						})
						.catch(error => {
							this.showError('Napaka odstranjevanju povračila!');
							if (error) {
								console.log(error);
							}
						});
				}
			}).catch(err => {
				console.log(err);
			})
		},
		table_rowClick: function (item, index) {
			this.showError(null);
		},
		table_dataProvider: function (ctx) {
			return service.getPovracilaFiltered(ctx, this.inputFilter, this.user)
				.then(data => {
					this.items = data.items;
					this.table.filterSum = data.sumItems;
					this.table.totalRows = data.items.total;
					return this.items.data;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
					this.totalRows = 0;
					return [];
				});
		},
		table_filterChange: function (value) {
			if (this.filterPovracilaTimeout !== null) {
				clearTimeout(this.filterPovracilaTimeout);
			}
			this.filterPovracilaTimeout = setTimeout(() => {
				this.$refs.dataTable.refresh();
			}, settings.filterTimeoutLength);
		},
		on_statusPovracilaFilterChange: function (selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.statusPovracila = [];
				for (let item of selectedItems) {
					this.inputFilter.statusPovracila.push(item.value);
				}
			} else {
				this.inputFilter.statusPovracila = null;
			}
			this.$refs.dataTable.refresh();
		},
		on_povracilaPotrjenaSuccess: function () {
			this.$refs.dataTable.refresh();
		},
		edit_add: function () {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Povračilo dodano');
		},
		edit_update: function () {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Povračilo posodobljeno');
		},
		edit_vozilo_find: function () {
			this.$refs.dataTable.refresh();
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		}
	},
	data: () => {
		return {
			table: {
				items: [],
				fields: [
					{ key: 'creditnotedate', label: 'Datum izdobave', sortable: true, class: 'seznamPovracilDatum' },
					{ key: 'chassis', label: 'Šasija', sortable: true, class: 'seznamPovracilOgrodje' },
					{ key: 'amount', label: 'Skupaj odobreno', sortable: true, class: 'seznamPovracilZnesek' },
					{ key: 'status', label: 'Status', sortable: false, class: 'seznamPovracilStatus' },
					{ key: 'sale_channel', label: 'Prodajni kanal', sortable: true, class: '' },
					{ key: 'actions', label: '#', class: 'seznamPovracilActions' }
				],
				currentPage: 1,
				perPage: 50,
				totalRows: 0,
				sortDesc: true,
				sortBy: 'created_at',
				filter: null,
				filterSum: null
			},
			inputFilter: {
				datum: null,
				chassis: '',
				amount: null,
				status: null,
				action_name: '',
				sale_channel: ''
			},
			filterPovracilaTimeout: null,
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR'
		};
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		message_class () {
			if (this.show_step_two) {
				return 'error_message_b';
			}
			return 'error_message';
		}
	},
	created () {
		/* let $main = this;
		this.$nextTick(() => {
			$main.$refs.uvoziModal.showModal();
		}); */
	}
};
</script>
<template>
	<div class="animated fadeIn">
		<b-alert :class="message_class" :variant="message.type && message.type === MESSAGE_TYPE_ERROR ? 'danger' : 'primary'" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<b-row>
			<b-col lg="12">
				<b-card>
					<div slot="header">
						<i class='icon-wallet'></i> Povračila
						<div class="card-actions">
							<a href="#uvoziPovracila" class="btn btn-setting" @click.prevent="click_openUvoziPovracila($event)"><i class="icon-cloud-upload"></i></a>
							<a href="#addPovracilo" class="btn btn-setting" @click.prevent="click_editPovracilo()"><i class="icon-plus"></i></a>
						</div>
					</div>
					<b-table
						ref="dataTable"
						responsive="sm"
						show-empty
						hover
						empty-text="Ni vnosov"
						empty-filtered-text="Ni zadetkov"
						:items="table_dataProvider"
						:fields="table.fields"
						:current-page="table.currentPage"
						:per-page="table.perPage"
						:filter="table.filter"
						:sort-by.sync="table.sortBy"
						:sort-desc.sync="table.sortDesc"
						@row-clicked="table_rowClick">
						<template slot="chassis" slot-scope="data" >
							<span v-if="data.item.id_vozila == null" class="noVIN"> {{ data.item.chassis }}</span>
							<span v-else> {{ data.item.chassis }}</span>
						</template>
						<template slot="amount" slot-scope="data" >
							<span> {{ data.item.amount | hr_money }}</span>
						</template>
						<template slot="status" slot-scope="data">
							<b-badge v-if="data.item.status == 0" variant="light">Bi naj dobili</b-badge>
							<b-badge v-if="data.item.status == 1" variant="warning">Smo zahtevali</b-badge>
							<b-badge v-if="data.item.status == 2" variant="success">Smo dobili</b-badge>
							<b-badge v-if="data.item.status == 3" variant="primary">Modro</b-badge>
						</template>
						<template slot="creditnotedate" slot-scope="data">
							<span>  {{ data.item.creditnotedate | hr_date }} </span>
						</template>
						<template slot="actions" slot-scope="data">
							<b-button ref="editPovracilo" class="m-1 seznamPovracilIconStyle" variant="primary" @click.stop="click_editPovracilo(data.item)" size="sm">
								<i class="fa fa-pencil-square-o"></i>
							</b-button>
							<b-button ref="removePovracilo" class="m-1 seznamPovracilIconStyle" variant="danger" @click.stop="click_removePovracilo(data.item)" size="sm">
								<i class="fa fa-remove"></i>
							</b-button>
						</template>
						<template slot="top-row">
							<td><datum-filter-dropdown v-model="inputFilter.datum" @input="table_filterChange" /></td>
							<td><b-form-input v-model="inputFilter.chassis" type="text" @input="table_filterChange" /></td>
							<td><znesek-filter-dropdown v-model="inputFilter.amount" @input="table_filterChange" /></td>
							<td><status-povracila-filter-dropdown ref="statusPovracilaDropdown" @change="on_statusPovracilaFilterChange" /></td>
							<td><b-form-input v-model="inputFilter.sale_channel" type="text" @input="table_filterChange" /></td>
							<td></td>
						</template>
						<template v-if="table.filterSum != null" slot="bottom-row">
							<td></td>
							<td colspan="2" class="sumLabel"><a class="page-link rows_total">Skupni znesek povračil: <b>{{ table.filterSum | hr_money }}</b></a></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</template>
					</b-table>
					<nav>
						<b-pagination :total-rows="table.totalRows" :per-page="table.perPage" v-model="table.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
					</nav>
				</b-card>
			</b-col>
		</b-row>
		<vue-toastr ref="toastr"></vue-toastr>
		<uvozi-povracila-modal v-on:povracilaPotrjena-success="on_povracilaPotrjenaSuccess" ref="uvoziPovracilaModal" />
		<edit-povracilo-modal @povracilo_add="edit_add" @povracilo_edit="edit_update" @povracilo_id_vozila_find="edit_vozilo_find" ref="editPovraciloModal" />
	</div>
</template>
<style scoped>

</style>
<style>
.seznamPovracilDatum {
	width: 180px;
}
.seznamPovracilOgrodje {
	width: 180px;
}
.seznamPovracilZnesek {
	width: 180px;
}
.seznamPovracilStatus {
	width: 120px;
}
.seznamPovracilActions {
	width: 120px;
}
.seznamPovracilIconStyle {
	min-width: 35px;
}
.b-table-top-row .form-control {
	padding: 0.375rem 0.375rem;
}
.dropdown-toggle::after {
	border: none;
}
.noVIN {
	color: red;
}
.sumLabel {
	text-align: right;
}
.page-link.rows_total {
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Povracila.vue